import store from "@/store";

const routes = [
  {
    path: "sales/sales-orders/:id",
    name: "salesorder",
    component: () => import("@/views/main/modules/Sales/SalesOrdersNew/SalesOrderGroupComponent"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Sales Orders",
      service: 0,
    },
  },
];

export default routes;
